import { Theme, alpha, Components } from "@mui/material/styles";
import { gray, warning } from "../themePrimitives";
import { CustomisationState } from "../../context/CustomisationContext";

export const feedbackCustomisations = (
  customTheme: CustomisationState
): Components<Theme> => ({
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
        backgroundColor: warning[100],
        color: theme.palette.text.primary,
        border: `1px solid ${alpha(warning[300], 0.5)}`,
        "& .MuiAlert-icon": {
          color: warning[500],
        },
        ...theme.applyStyles("dark", {
          backgroundColor: `${alpha(warning[900], 0.5)}`,
          border: `1px solid ${alpha(warning[800], 0.5)}`,
        }),
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiDialog-paper": {
          borderRadius: "10px",
          border: "1px solid",
          borderColor: theme.palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles("dark", {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
});
